import { SectionContainer } from 'ui';
import { sectionContainer } from './publish-share.module.scss';
import { LayoutContainer } from 'layout';

import publicCards from 'images/public-cards.png';
import knowledge from 'images/knowledge.png';
import { Module, ScreenshotAndText } from 'shared/components/screenshot-text/ScreenshotAndText';

export const PublishShareSection = () => {
    return (
        <>
            <LayoutContainer>
                <SectionContainer className={sectionContainer}>
                    <ScreenshotAndText
                        title="Find cards. Share cards."
                        text="Search Elumity Discover for great cards from other peers. Follow colleagues and apply the knowledge of fellow experts. Post your cards and contribute to advancing knowledge in your field."
                        module={Module.CARDS}
                        image={publicCards}
                        altText="cards"
                        reverse={true}
                    />
                    <ScreenshotAndText
                        title="Test your knowledge"
                        text="Create quizzes instantly from your annotations or cards. Use microlearning on your Elumity smartphone app. Follow your progress and advance more quickly."
                        module={Module.QUIZ}
                        image={knowledge}
                        altText="cards"
                    />
                </SectionContainer>
            </LayoutContainer>
        </>
    );
};
